
import { Page, Model, Dialog } from 'web-mojo';

export default class LicensePage extends Page {
    constructor(options = {}) {
        super({
            title: 'License',
            pageName: "home",
            route: "home",
            template: `
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h4 class="mb-0">{{model.description}}</h4>
              <button class="btn btn-primary btn-sm" data-action="edit-license">
                <i class="bi bi-pencil me-1"></i>Edit License
              </button>
            </div>
            <div class="license-header mb-4">
              <div class="row">

              <div class="col-xl-4 col-lg-6 col-12 mb-3">
                <div class="card h-100 border-0 shadow">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-start">
                      <div>
                        <h6 class="card-title text-muted mb-2">Licenses</h6>
                        <h3 class="mb-1 fw-bold">{{model.active|default:0}} of {{model.allocated|default:0}}</h3>

                      </div>
                      <div class="text-other">
                        <i class="bi bi-award fs-2"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

                <div class="col-xl-4 col-lg-6 col-12 mb-3">
                  <div class="card h-100 border-0 shadow">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-start">
                        <div>
                          <h6 class="card-title text-muted mb-2">Users</h6>
                          <h3 class="mb-1 fw-bold">{{model.user_count|default:0}}</h3>
                        </div>
                        <div class="text-primary">
                          <i class="bi bi-people fs-2"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4 col-lg-6 col-12 mb-3">
                  <div class="card h-100 border-0 shadow">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-start">
                        <div>
                          <h6 class="card-title text-muted mb-2">Locks</h6>
                          <h3 class="mb-1 fw-bold">{{model.lock_count|default:0}}</h3>
                        </div>
                        <div class="text-info">
                          <i class="bi bi-lock fs-2"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="license-details mt-5">
              <div class="row">

                <div class="col-lg-6 col-12 mb-4">
                  <div class="card border-0 shadow-sm h-100">
                    <div class="card-body">
                      <div class="d-flex align-items-center mb-3">
                        <i class="bi bi-credit-card text-success fs-4 me-2"></i>
                        <h5 class="mb-0">Billing & Pricing</h5>
                      </div>
                      <div class="mb-3">
                        <p class="text-muted mb-2">Current Package</p>
                        <p class="mb-0 fw-semibold">{{model.kind|default:'N/A'}}</p>
                      </div>
                      <div class="mb-3">
                        <p class="text-muted mb-2">Monthly Rate</p>
                        {{#model.price}}
                        <h4 class="mb-0 text-success">
                         {{model.price|currency}}
                        </h4>
                        {{/model.price}}
                        {{^model.price}}
                        <h4 class="mb-0">
                          <span class="badge bg-success">Free Trial</span>
                        </h4>
                        {{/model.price}}
                      </div>
                      <div class="mb-3">
                        <p class="text-muted mb-2">License Structure</p>
                        <p class="mb-1"><i class="bi bi-person-badge me-2"></i>Per User License</p>
                        <p class="mb-0"><i class="bi bi-lock me-2"></i>Per Lock License</p>
                      </div>
                      <div>
                        <p class="text-muted mb-2">Billing Frequency</p>
                        <p class="mb-0 fw-semibold">{{model.billing_frequency|default:'Monthly'}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-12 mb-4">
                  <div class="card border-0 shadow-sm h-100">
                    <div class="card-body">
                      <div class="d-flex align-items-center mb-3">
                        <i class="bi bi-shield-check text-info fs-4 me-2"></i>
                        <h5 class="mb-0">Warranty & Support</h5>
                      </div>
                      <div class="mb-3">
                        <p class="text-muted mb-2">Hardware Warranty</p>
                        <p class="mb-0">All digital locks include a {{model.warranty_period|default:'1-year'}} manufacturer warranty covering defects in materials and workmanship.</p>
                      </div>
                      <div class="mb-3">
                        <p class="text-muted mb-2">Software Updates</p>
                        <p class="mb-0">Free updates and security patches included with active subscription.</p>
                      </div>
                      <div>
                        <p class="text-muted mb-2">Technical Support</p>
                        <p class="mb-0">24/7 customer support via email and phone for all licensed users.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="card border-0 shadow-sm bg-light">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col-lg-8 mb-3 mb-lg-0">
                          <h6 class="mb-2"><i class="bi bi-info-circle me-2"></i>License Information</h6>
                          <p class="mb-0 text-muted small">
                            Your subscription includes one license per user and one license per lock.
                            Need additional licenses? Contact your account manager or visit our billing portal to upgrade your plan.
                          </p>
                        </div>
                        <div class="col-lg-4 text-lg-end">
                          <button class="btn btn-primary btn-sm me-2">
                            <i class="bi bi-plus-circle me-1"></i>Add Licenses
                          </button>
                          <button class="btn btn-outline-secondary btn-sm">
                            <i class="bi bi-file-text me-1"></i>View Invoice
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            `,
            ...options
        });
    }

    async onEnter() {
        await super.onEnter();
        this.setModel(new Model({}, { endpoint: '/api/acs/license/group/package/' }))
        this.model.id = this.getApp().activeGroup.id;
        this.model.fetch();
    }

    async onGroupChange(group) {
        if (group) {
            this.setModel(new Model({}, { endpoint: '/api/acs/license/group/package/' }))
            this.model.id = group.id;
            this.model.fetch();
        }
    }

    async onActionEditLicense() {
        const result = await this.getApp().showForm({
            title: 'Edit License',
            size: 'lg',
            submitText: 'Save Changes',
            cancelText: 'Cancel',
            fields: [
                {
                    name: 'description',
                    label: 'Description',
                    type: 'text',
                    value: this.model.get('description'),
                    required: true
                },
                {
                    name: 'kind',
                    label: 'Package Kind',
                    type: 'text',
                    value: this.model.get('kind'),
                    required: true,
                    help: 'e.g., acs_beta_1, acs_standard_1'
                },
                {
                    name: 'allocated',
                    label: 'Allocated Licenses',
                    type: 'number',
                    value: this.model.get('allocated'),
                    min: 0,
                    required: true
                },
                {
                    name: 'price',
                    label: 'Price',
                    type: 'number',
                    value: this.model.get('price'),
                    min: 0,
                    step: 0.01,
                    required: true
                },
                {
                    name: 'currency',
                    label: 'Currency',
                    type: 'select',
                    value: this.model.get('currency'),
                    required: true,
                    options: [
                        { value: 'USD', label: 'USD' },
                        { value: 'EUR', label: 'EUR' },
                        { value: 'GBP', label: 'GBP' },
                        { value: 'CAD', label: 'CAD' }
                    ]
                },
                {
                    name: 'billing_frequency',
                    label: 'Billing Frequency',
                    type: 'text',
                    value: this.model.get('billing_frequency') || 'Monthly'
                },
                {
                    name: 'warranty_period',
                    label: 'Warranty Period',
                    type: 'text',
                    value: this.model.get('warranty_period') || '1-year'
                }
            ]
        });

        if (result) {
            try {
                await this.model.save(result);
                await this.getApp().showSuccess('License updated successfully');
                await this.render();
            } catch (error) {
                await this.getApp().showError('Failed to save license: ' + error.message);
            }
        }
    }
}
